import { render, staticRenderFns } from "./DisplayRegistrationSummary.vue?vue&type=template&id=6a472ca9"
import script from "./DisplayRegistrationSummary.vue?vue&type=script&lang=js"
export * from "./DisplayRegistrationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports